import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import ItemService from "../../../services/plm_appCommonService";

const initialState = {
  article: {
    data: [],
    status: true,
    articleNr: "",
    workflow: [],
    pagination: {
      page: "",
      per_page: "",
      total: "",
    },
  },
};

export const plmSlice = createSlice({
  name: "plm",
  initialState,
  reducers: {
    articleNr(state, action) {
      state.article.articleNr = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getArticleList.pending, (state, action) => {
        state.article.status = true;
      })
      .addCase(getArticleList.fulfilled, (state, action) => {
        state.article.data = action.payload.data;
        state.article.pagination.page = action.payload.page;
        state.article.pagination.per_page = action.payload.per_page;
        state.article.pagination.total = action.payload.total;
        state.article.status = false;
      });
  },
});

export const { articleNr } = plmSlice.actions;

export const getArticleList = createAsyncThunk(
  "getArticleList",
  async (param) => {
    console.log(">> loaded getArticleList");
    const res = await ItemService.generatePlmQuery(param);
    return res;
  }
);

export default plmSlice.reducer;
